<template>
  <div class="collection-wrapper">
    <div class="header">
      {{ $t(errorHeading) }}
    </div>
    <div class="main">{{ $t(errorMsg) }}</div>
    <div class="collect-btn" @click="$emit('hidePopup')">
      {{ $t('Close') }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('menu', ['errorMsg', 'errorHeading']),
  },
};
</script>

<style lang="scss" scoped>
.collection-wrapper {
  height: 100%;
  width: 100%;
  padding: 20px 12px;
  box-sizing: border-box;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;

  .header {
    width: 100%;
    height: 20px;
    font-size: 26px;
    font-weight: 800;
    text-align: center;
    text-transform: uppercase;
  }

  .main {
    display: flex;
    height: 180px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    width: 100%;
    font-size: 18px;
    text-transform: uppercase;
  }

  .collect-btn {
    height: 40px;
    padding: 0 1px;
    padding: 10px 21px 10px 22px;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.4);
    background-image: linear-gradient(to bottom, #f4ea9f, #eac35a);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #602b04;
    box-sizing: border-box;
    cursor: pointer;
  }
}
</style>
